export default "__VITE_ASSET__e5270b7a__"